import { render, staticRenderFns } from "./RepairDetailView.vue?vue&type=template&id=cb3fb53c&scoped=true&lang=pug"
import script from "./RepairDetailView.vue?vue&type=script&lang=js"
export * from "./RepairDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3fb53c",
  null
  
)

export default component.exports